/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.10
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InternalCommonStorageUploadMetadataFromJSON, InternalCommonStorageUploadMetadataToJSON, } from './InternalCommonStorageUploadMetadata';
/**
 * Check if a given object implements the InternalCommonStorageUpload interface.
 */
export function instanceOfInternalCommonStorageUpload(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('blobId' in value) || value['blobId'] === undefined)
        return false;
    if (!('metadata' in value) || value['metadata'] === undefined)
        return false;
    return true;
}
export function InternalCommonStorageUploadFromJSON(json) {
    return InternalCommonStorageUploadFromJSONTyped(json, false);
}
export function InternalCommonStorageUploadFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'blobId': json['blob_id'],
        'metadata': InternalCommonStorageUploadMetadataFromJSON(json['metadata']),
    };
}
export function InternalCommonStorageUploadToJSON(json) {
    return InternalCommonStorageUploadToJSONTyped(json, false);
}
export function InternalCommonStorageUploadToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'blob_id': value['blobId'],
        'metadata': InternalCommonStorageUploadMetadataToJSON(value['metadata']),
    };
}
